"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithClarity = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const config_1 = __importDefault(require("next/config"));
const head_1 = __importDefault(require("next/head"));
const react_1 = __importStar(require("react"));
function appWithClarity(WrappedAppComponent) {
    const { publicRuntimeConfig = {} } = (0, config_1.default)();
    const { clarityKey = '' } = publicRuntimeConfig;
    if (!clarityKey)
        return WrappedAppComponent;
    function AppWithClarity(props) {
        const head = (0, react_1.useMemo)(() => (react_1.default.createElement(head_1.default, null,
            react_1.default.createElement("script", { key: "clarity-init", dangerouslySetInnerHTML: {
                    __html: `
                (function(c,l,a,r,i,t,y){
                  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "${clarityKey}");
              `,
                } }))), []);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(WrappedAppComponent, Object.assign({}, props)),
            head));
    }
    return (0, hoist_non_react_statics_1.default)(AppWithClarity, WrappedAppComponent);
}
exports.appWithClarity = appWithClarity;
//# sourceMappingURL=appWithClarity.js.map